module.exports = __webpack_public_path__ + "static/media/howwork-2.97718bd5.svg";